'use client'

import { ComponentProps, ReactNode } from 'react'

import {
  ThemeProvider as DesignSystemThemeProvider,
  useTheme
} from '@themenu/design-system'
import { SkeletonTheme } from 'react-loading-skeleton'

function MergedThemeProvider({ children }: { children: ReactNode }) {
  const theme = useTheme()

  return (
    <SkeletonTheme
      baseColor={theme.colors.background.contrast}
      highlightColor={theme.colors.background.default}
      duration={1}
    >
      {children}
    </SkeletonTheme>
  )
}

export function ThemeProvider({
  children,
  ...props
}: ComponentProps<typeof DesignSystemThemeProvider>) {
  return (
    <DesignSystemThemeProvider {...props}>
      <MergedThemeProvider>{children}</MergedThemeProvider>
    </DesignSystemThemeProvider>
  )
}
